
import { styled } from '@mui/material';

export const StyledVow = styled('section')`
  margin-top: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h2 {
    font-size: 48px;
    font-weight: 500;
    text-align: center;
    color: #2B2B2B;
    font-family: "YesevaOne", serif;
    @media (max-width: 725px) {
      text-align: center;
      line-height: 54px;
    }
    @media (max-width: 480px) {
      font-size: 26px;
      line-height: 29px;
    }
  }
  span {
    margin-top: 80px;
    font-size: 80px;
    font-weight: 600;
    @media (max-width: 480px) {
      font-size: 72px;
    }
  }
  @media (max-width: 480px) {
    margin-top: 160px;
  }
  button {
      position: relative;
      padding: 17px 60px 17px 40px;
    margin-top: 24px;
    border: 2px solid #2DB3F6;
    box-shadow: 0px 0px 16px -2px rgba(45, 179, 246, 0.6);
    color: #2DB3F6;
    font-size: 18px;
    font-weight: 700;
    border-radius: 63px;
    background: transparent;
    font-family: "Montserrat", sans-serif;
    transition: background 0.3s ease;
    opacity: 0;
    transform: translateY(-50px);
    animation: fadeInFromTop 1s ease-out forwards;
    animation-delay: 1s;

    &:hover {
      background: #fff;
      border-color: transparent;
      color: #000;
      cursor: pointer;
    }
    @media (max-width: 680px) {
        margin-top: 15px;
        font-size: 16px;
    }
  }
`;

export const SubtitleText = styled('p')`
  margin-top: 12px;
    font-family: "CormorantInfant", serif;
    font-size: 24px;
    font-weight: 400;
    color: #2B2B2B;
  text-align: center;
  margin-bottom: 65px;
  @media (max-width: 992px) {
    text-align: center;
  }
  @media (max-width: 480px) {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 5px;
  }
`;

export const InfoWrapper = styled('div')`
  margin-top: 0px;
  @media (max-width: 480px) {
    margin-top: 24px;
  }
  background: linear-gradient(0deg, #fff 0%, #fff 100%);
  border: 1px solid #eee;
  display: flex;
  padding: 32px;
  border-radius: 24px;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  @media (max-width: 992px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const InfoItem = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h4 {
    margin-top: 16px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color:#4b4b4b
  }
`;

export const InfoItemText = styled('p')`
  margin-top: 8px;
  text-align: center;
  font-size: 16px;
  font-weight: 300;
  opacity: 0.8;
  color:#4b4b4b
`;

export const VideoIcon = styled('img')`
    width: 50px
`;

export const PrivateIcon = styled('img')`
    width: 50px
`;

export const RingIcon = styled('img')`
    width: 50px
`;

export const CertIcon = styled('img')`
    width: 50px
`;


export const RegionWrapper = styled('div')`
  margin-top: 40px;
  max-width: 346px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  a {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    text-decoration: underline;
  }
`;

export const RegionFlags = styled('img')``;
